import { render, staticRenderFns } from "./GeneralSettingsForm.vue?vue&type=template&id=5ffa416a&scoped=true&"
import script from "./GeneralSettingsForm.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingsForm.vue?vue&type=style&index=0&id=5ffa416a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa416a",
  null
  
)

export default component.exports